export default __webpack_public_path__ + "static/media/top-k-5.844e31a8.jpg";